import { useState } from 'react';
import { ChevronRight, User } from 'lucide-react';
import { shortenAnchor, type ArcturianEnvelope } from '../lib/arcturianEnvelope';
import './ArcturianMessage.css';

// Eine Arcturian-Zustellung als Protokoll statt als Textwand (Alex 2026-08-06,
// Screenshot 118435: die Frage ging zwischen action_id, in_reply_to und
// authority unter).
//
// Die Aufteilung folgt der Frage „wer liest das?": Der Satz ist für den
// Menschen, die Anker sind für die Fehlersuche, und `reply=` ist eine
// Anweisung an den EMPFANGENDEN AGENTEN — für einen Leser schlicht falsch
// adressiert. Deshalb: Satz gross, Anker klein und aufklappbar, Antwortweg
// nur auf Wunsch.

const LABEL: Record<string, string> = {
  action_id: 'Auftrag',
  in_reply_to: 'Antwort auf',
  authority: 'Befugnis',
};

export function ArcturianMessage({ env }: { env: ArcturianEnvelope }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="arcmsg">
      <div className="arcmsg-head">
        <span className="arcmsg-persona">{env.persona}</span>
        <span className="arcmsg-behalf">
          <User size={10} /> im Auftrag von {env.onBehalfOf}
        </span>
        <span className="arcmsg-channel">{env.channel}</span>
      </div>

      {/* Der eigentliche Inhalt — in Lesegrösse, nicht in Monospace. */}
      <div className="arcmsg-body">{env.body}</div>

      {env.fields.length > 0 && (
        <button
          type="button"
          className={`arcmsg-toggle${open ? ' open' : ''}`}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
        >
          <ChevronRight size={11} />
          {open ? 'Protokolldaten ausblenden' : `Protokolldaten (${env.fields.length})`}
        </button>
      )}

      {open && (
        <dl className="arcmsg-fields">
          {env.fields.map((f) => (
            <div key={f.key} className="arcmsg-field">
              <dt>{LABEL[f.key] || f.key}</dt>
              {/* Voller Wert im title: die Kurzform ist zum Lesen, der
                  vollständige Anker zum Abgleich mit einem Log. */}
              <dd title={f.value}>{shortenAnchor(f.value)}</dd>
            </div>
          ))}
          {env.replySpec && (
            <div className="arcmsg-field arcmsg-field-wide">
              <dt>Antwortweg</dt>
              <dd title={env.replySpec}>{env.replySpec}</dd>
            </div>
          )}
        </dl>
      )}
    </div>
  );
}
